const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

const BASE = API_URL + '/api/crypto'

export interface CryptoPrice {
  name?: string
  imageUrl?: string
  usd: number
  usd_24h_change: number
  marketCap?: number
  volume24h?: number
}

/**
 * Backend'den kripto fiyatlarını çeker (Redis cache'li).
 * Backend → CoinGecko → Redis
 */
export async function fetchCryptoPrices(
  symbols: string[],
): Promise<Record<string, CryptoPrice>> {
  try {
    const res = await fetch(`${BASE}/quotes?symbols=${symbols.join(',')}`)
    if (!res.ok) return {}
    const data = await res.json()

    // Backend CryptoQuote → frontend CryptoPrice dönüşümü
    const result: Record<string, CryptoPrice> = {}
    for (const [sym, q] of Object.entries(data)) {
      const quote = q as { name?: string; imageUrl?: string; price: number; change24h: number; marketCap?: number; volume24h?: number }
      result[sym] = {
        name: quote.name,
        imageUrl: quote.imageUrl,
        usd: quote.price,
        usd_24h_change: quote.change24h,
        marketCap: quote.marketCap,
        volume24h: quote.volume24h,
      }
    }
    return result
  } catch {
    return {}
  }
}

export interface CryptoChartPoint {
  time: string
  open: number
  high: number
  low: number
  close: number
}

/**
 * Backend'den kripto OHLC chart verisi çeker (Redis cache'li).
 * Backend → CoinGecko /ohlc → Redis
 */
export async function fetchCryptoChartData(
  symbol: string,
  period: string,
): Promise<CryptoChartPoint[]> {
  try {
    const res = await fetch(`${BASE}/chart?symbol=${encodeURIComponent(symbol)}&period=${period}`)
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}
